module.exports = __webpack_public_path__ + "img/index02.a8b5db9b.jpg";